<script>
    // imports
    import Button from '../shared/Button.svelte';

    // exports
    export let data;

    //console.log("Buttons: ", data);
</script>

<div class="text-{data.storageSolutionsAlignment}">
    {#each data.storageSolutionsButton as button, i}
        <Button 
            title="{button.buttonTitle}" 
            link="{button.buttonLink}" 
            cssClass="{i === 0 ? 'default' : 'outlined'}"
            singleButton="{data.storageSolutionsButton.length === 1 ? true : false}"
        />
    {/each}
</div>